import React from 'react'
import { ReactComponent as Visa } from './../../assets/payment_methods/visa.svg'
import { ReactComponent as Amex } from './../../assets/payment_methods/amex.svg'
import { ReactComponent as Diners } from './../../assets/payment_methods/diners.svg'
import { ReactComponent as Discover } from './../../assets/payment_methods/discover.svg'
import { ReactComponent as Generic } from './../../assets/payment_methods/generic.svg'
import { ReactComponent as Jcb } from './../../assets/payment_methods/jcb.svg'
import { ReactComponent as Maestro } from './../../assets/payment_methods/maestro.svg'
import { ReactComponent as Mastercard } from './../../assets/payment_methods/mastercard.svg'
import { ReactComponent as Unionpay } from './../../assets/payment_methods/unionpay.svg'

interface IPaymentMethodIconProps {
  brand: string
}

function PaymentMethodIcon({ brand }: IPaymentMethodIconProps): JSX.Element {
  const brandLower = brand.toLowerCase()

  switch (brandLower) {
    case 'visa':
      return <Visa width={'35px'} height={'24px'} />
    case 'amex':
    case 'american express':
      return <Amex width={'35px'} height={'24px'} />
    case 'diners':
    case 'diners club':
      return <Diners width={'35px'} height={'24px'} />
    case 'discover':
      return <Discover width={'35px'} height={'24px'} />
    case 'jcb':
      return <Jcb width={'35px'} height={'24px'} />
    case 'maestro':
      return <Maestro width={'35px'} height={'24px'} />
    case 'mastercard':
      return <Mastercard width={'35px'} height={'24px'} />
    case 'unionpay':
    case 'union pay':
      return <Unionpay width={'35px'} height={'24px'} />
    default:
      return <Generic width={'35px'} height={'24px'} />
  }
}

export { PaymentMethodIcon }
